import { useState } from 'react'

import { ColorModalDialog } from 'core-components/library/common'

import { DEFAULT_BUTTON_TITLE } from './constants/names'
import { IColorSelectorButtonProps } from './models/IColorSelectorButtonProps'

import styles from './ColorSelectorButton.module.scss'

export const ColorSelectorButton = ({
  color,
  onChange,
  className,
  buttonText = DEFAULT_BUTTON_TITLE,
}: IColorSelectorButtonProps) => {
  const [colorDialogVisible, setColorDialogVisible] = useState<boolean>(false)

  return (
    <div className={className}>
      <div className={styles.wrapper} onClick={() => setColorDialogVisible(true)}>
        <div className={styles.colorMarker} style={{ backgroundColor: color }}></div>
        <div className={styles.separatorWrapper}>
          <div className={styles.separator}></div>
        </div>
        <div className={styles.label}>{buttonText}</div>
      </div>

      <ColorModalDialog
        visible={colorDialogVisible}
        onClose={() => setColorDialogVisible(false)}
        value={color}
        onChange={onChange}
      />
    </div>
  )
}
